import React from "react";
// style components
import { Row, Col, Modal, Form, Input, Button } from "antd";
import { initialValuesPublicacionesmodel, PublicacionesModel } from "../../../models/Publicaciones/Publicaciones";
// hooks
import { usePublicaciones } from "../../../hooks/usePublicaciones";
import DocumentInput from "../../../utils/DocumentInput";
import { InputNumero } from "../../../components/Mascaras/InputNumero/InputNumero";
import moment from "moment";
import DocumentosService  from "../../../api/Documentos/api-documentos";

// models
interface IProps {
   publicacion: PublicacionesModel;
   setPublicacion: any;
   publicaciones: Array<PublicacionesModel>;
   setPublicaciones: any;
   modal: boolean;
   setModal: any;
   guardarcambios: any;
   limpiarcampos: any;
}

export const Modaleditarpublicaciones: React.FC<IProps> = (props: IProps) => {
   const { fileInputRef, guardarArchivoeditar } = usePublicaciones();
   const fields = [
      { name: "titulo_publicacion", value: props.publicacion.titulo_publicacion },
      { name: "tema", value: props.publicacion.tema },
      { name: "año", value: props.publicacion.año },
      { name: "ciudad", value: props.publicacion.ciudad },
      { name: "descripcion", value: props.publicacion.descripcion },
      { name: "documento", value: props.publicacion.documento },
   ];

   const onCancel = () => {
      props.setPublicacion(initialValuesPublicacionesmodel)
      props.setModal(false)
   }

   const guardarArchivo = async (e: any) => {
      if (e.target.files.length > 0) {
        const formData = new FormData();
        formData.append("archivo", e.target.files[0]);
        const data = await DocumentosService.guardarArchivo(formData);
        return props.setPublicacion({ ...props.publicacion, documento: data.data });
      }
    };

   return (
      <Modal
         title={
            <span className="font-family-Montserrat-Bold">
               Editar publicaciones {(<div className="d-sm d-md-none"></div>)}
               <span>
                  - <span className="font-color-DB2828 font-size-10px font-family-Montserrat-Regular">
                     Todos los campos son obligatorios
                  </span>
               </span>

            </span>
         }
         style={{ top: 60 }}
         width={1600}
         visible={props.modal}
         onCancel={onCancel}
         footer={[
            <div key="Contenedor_Botones_ModalEditarPublicacion" className="d-flex justify-content-end">
               <div className='row g-2'>
                  <div className='col align-self-end'>
                     <Button className="button-gray-ghost pe-1 me-0" key="back" onClick={onCancel} >Cancelar</Button>
                  </div>
                  <div className='col align-self-end'>
                     <Button className="button-azul-ghost" style={{ marginBottom: '20px' }} onClick={() => props.limpiarcampos()}>
                        Limpiar campos
                     </Button>
                  </div>
                  <div className="col align-self-end me-md-2">
                     <Button className="button-azul-radius" form="modaleditarpublicacion" key="submit" htmlType="submit">
                        Guardar cambios
                     </Button>
                  </div>
               </div>
            </div>



         ]}
         maskStyle={{
            backgroundColor: "rgba(6, 100, 144 ,0.8)",
         }}
      >
         <Form
            size="large"
            name="modaleditarpublicacion"
            fields={fields}
            onFinish={() => {
               props.guardarcambios();
            }}
            onFieldsChange={(_, fields: any) => {
               let infoupdate: any = { ...props.publicacion };
               for (var i in fields) {
                  infoupdate[fields[i].name] = fields[i].value;
               }
               props.setPublicacion(infoupdate);
            }}
         >
            <div className="row">
               <div className="col-12 col-md-6 container-form-jurados-input-left mt-3">
                  <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
                     Título de la publicación
                  </span>
                  <Form.Item
                     className="no-margin"
                     name="titulo_publicacion"
                     rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                     <Input />
                  </Form.Item>
               </div>
               <div className="col-12 col-md-6 col-lg-3 mt-3">
                  <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
                     Tema
                  </span>
                  <Form.Item className="no-margin" name="tema" rules={[{ required: true, message: "Campo obligatorio" }]}>
                     <Input />
                  </Form.Item>
               </div>
               <div className="col-12 col-md-6 col-lg-3 mt-3">
                  <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
                     Año
                  </span>
                  <Form.Item className="no-margin" name="año" rules={[
                     { required: true, message: "Campo obligatorio" },
                     { max: 4, message: "Máximo 4 números" },
                     { min: 4, message: "Mínimo 4 números" },
                  ]}>
                     {/* <Input /> */}
                     <InputNumero
                        name="año"
                        max={4}
                        texto={props.publicacion.año}
                        setTexto={props.setPublicacion}
                        alltexto={props.publicacion}
                        año={parseInt(moment().format("YYYY"))}
                     />
                  </Form.Item>
               </div>
               <div className="col-12 col-md-6 col-lg-6 mt-3">
                  <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
                     Ciudad
                  </span>
                  <Form.Item className="no-margin" name="ciudad" rules={[{ required: true, message: "Campo obligatorio" }]}>
                     <Input />
                  </Form.Item>
               </div>
               <div className="col-12 col-md-6 mt-3">
                  <span className="width-100 no-margin font-family-Montserrat-SemiBold font-size-12px">
                     Anexar documento
                  </span>
                  <Form.Item className="no-margin" name="documento" rules={[{ required: true, message: "Documento Obligatorio" }]}>
                     <DocumentInput
                        doc={props.publicacion.documento}
                        fileInputRef={fileInputRef}
                        ancho_btn={30}
                        on_change={(e) => {
                           guardarArchivo(e)
                           e.target.value = ""
                        }}
                        onDelete={() => {
                           props.setPublicacion({
                              ...props.publicacion,
                              documento: "",
                           });
                        }}
                     />
                     {/* <Input.Group compact>
                              <Input
                                 style={{ width: "70%" }}
                                 disabled={true}
                                 value={props.publicacion.documento}
                              />
                              <Button
                                 style={{ width: "30%" }}
                                 className="buttonblanco-radius-input"
                                 onClick={() => fileInputRef.current.click()}
                              >
                                 ADJUNTAR
                              </Button>
                              <input
                                 ref={fileInputRef}
                                 type="file"
                                 hidden
                                 onChange={(e) => {
                                    guardarArchivoeditar(e, props.publicaciones)
                                    e.target.value = ""
                                 }}
                              />
                           </Input.Group> */}
                  </Form.Item>
               </div>
               <div className="col-12 col-md-12 col-lg-12 mt-3">
                  <span className="width-100 font-family-Montserrat-SemiBold font-size-12px container-span-titulos-bottom">
                     Breve descripción
                  </span>
                  <Form.Item className="no-margin" name="descripcion" rules={[{ required: true, message: "Campo obligatorio" }]}>
                     <Input.TextArea maxLength={300} showCount={true} />
                  </Form.Item>
               </div>

            </div>
         </Form>
      </Modal>
   );
};
